import React, { Fragment } from 'react'
import Img1 from "../images/smash-queen-image-1.png"
import Img2 from "../images/smash-queen-image-2.png"
import Img5 from "../images/menu-three-burgers-1.png"
import Img6 from "../images/menu-three-burgers-2.png"
import Img7 from "../images/menu-three-burgers-3.png"
import Img8 from "../images/menu-three-burgers-4.png"
import Img9 from "../images/menu-three-dish-1.png"
import Img10 from "../images/menu-three-dish-2.png"
import Img11 from "../images/menu-three-dish-3.png"
import { Link } from 'react-router-dom'

const MenuTwo = () => {
    return (
        <Fragment>
            <section className="p-[2vmax_1vmax] customBG-7">
                <div className='grid grid-cols-[1fr_2fr_1fr] items-center' >
                    <div>
                        <img src={Img1} alt="Smash Queen" className='w-full object-contain' />
                    </div>
                    <div className='rotate-[-5deg]' >
                        <h2 className='text-[6vmax] font-[900] text-center uppercase bg-gradient-to-r from-[#FA3F77]  to-[#FA8907] bg-clip-text text-transparent'
                        >
                            Smash Queen
                        </h2>
                        <h3 className='text-[2vmax]  uppercase font-extrabold text-white text-center' >
                            <i className="fa-solid fa-star text-[#F53F72]"></i>
                            &nbsp;&nbsp;&nbsp;    Street Burgers&nbsp;&nbsp;&nbsp;
                            <i className="fa-solid fa-star text-[#FA8907]"></i>

                        </h3>
                    </div>
                    <div>
                        <img src={Img2} alt="Smash Queen" className='w-full object-contain' />
                    </div>
                </div>
                <div className="grid grid-cols-[1fr_1fr] gap-[0vmax] ">
                    <div className="customBG-8 aspect pt-[2vmax] px-[3vmax] pb-[5vmax]">
                        <h3 className='text-[2.4vmax] uppercase  rotate-[-5deg]  font-extrabold font-4   flex-center customBG-10 text-black py-[1vmax]' >
                            Burgers
                        </h3>
                        <div className="grid grid-cols-[2.5fr_1fr_1fr] items-center">
                            <div className='p-[2vmax] '>
                                <div className="grid  items-center border-b-[0.2vmax]  border-dashed border-[#FA8907] pb-[1vmax]">

                                    <div>
                                        <h4 className='text-[1.4vmax] font-4 font-extrabold  font-bold text-white mb-[0.5vmax]' >
                                            Smash Cheese Burger
                                        </h4>
                                        <p className='text-white font-[400] text-[1vmax]' >
                                            Secret sauce, served with fries
                                        </p></div>
                                </div>
                            </div>
                            <div className="">
                                <img src={Img5} alt="" className='scale-[1.5] ml-[-1vmax]' />
                            </div>
                            <h3 className='text-[2vmax] uppercase  rotate-[-5deg]  font-extrabold font-1   flex-center customBG-11 text-black pt-[0.5vmax] pb-[1vmax]' >
                                $ 11.99
                            </h3>
                        </div>
                        <div className="grid grid-cols-[2.5fr_1fr_1fr] items-center">
                            <div className='p-[2vmax] '>
                                <div className="grid  items-center border-b-[0.2vmax]  border-dashed border-[#F53F72] pb-[1vmax]">

                                    <div>
                                        <h4 className='text-[1.4vmax] font-4 font-extrabold  font-bold text-white mb-[0.5vmax]' >
                                            California Smash Burger
                                        </h4>
                                        <p className='text-white font-[400] text-[1vmax]' >
                                            Secret sauce, grilled pineapple, american cheese
                                        </p></div>
                                </div>
                            </div>
                            <div className="">
                                <img src={Img6} alt="" className='scale-[1.5] ml-[-1vmax]' />
                            </div>
                            <h3 className='text-[2vmax] uppercase  rotate-[-5deg]  font-extrabold font-1   flex-center customBG-12 text-black pt-[0.5vmax] pb-[1vmax]' >
                                $ 13.99
                            </h3>
                        </div>
                        <div className="grid grid-cols-[2.5fr_1fr_1fr] items-center">
                            <div className='p-[2vmax] '>
                                <div className="grid  items-center border-b-[0.2vmax]  border-dashed border-[#FA8907] pb-[1vmax]">

                                    <div>
                                        <h4 className='text-[1.4vmax] font-4 font-extrabold  font-bold text-white mb-[0.5vmax]' >
                                            Astro’s Game Smash
                                        </h4>
                                        <p className='text-white font-[400] text-[1vmax]' >
                                            Secret sauce, grilled pineapple.
                                        </p></div>
                                </div>
                            </div>
                            <div className="">
                                <img src={Img7} alt="" className='scale-[1.5] ml-[-1vmax]' />
                            </div>
                            <h3 className='text-[2vmax] uppercase  rotate-[-5deg]  font-extrabold font-1   flex-center customBG-11 text-black pt-[0.5vmax] pb-[1vmax]' >
                                $ 15.99
                            </h3>
                        </div>
                        <div className="grid grid-cols-[2.5fr_1fr_1fr] items-center">
                            <div className='p-[2vmax] '>
                                <div className="grid  items-center border-b-[0.2vmax]  border-dashed border-[#F53F72] pb-[1vmax]">

                                    <div>
                                        <h4 className='text-[1.4vmax] font-4 font-extrabold  font-bold text-white mb-[0.5vmax]' >
                                            Surf & Turf Smash
                                        </h4>
                                        <p className='text-white font-[400] text-[1vmax]' >
                                            Shrimp, smashed pattie, avocado sauce, secret sauce
                                        </p></div>
                                </div>
                            </div>
                            <div className="">
                                <img src={Img8} alt="" className='scale-[1.5] ml-[-1vmax]' />
                            </div>
                            <h3 className='text-[2vmax] uppercase  rotate-[-5deg]  font-extrabold font-1   flex-center customBG-12 text-black pt-[0.5vmax] pb-[1vmax]' >
                                $ 17.99
                            </h3>
                        </div>
                    </div>
                    <div className="customBG-9 aspect pt-[3vmax] px-[3vmax] ">
                        <h3 className='text-[2.4vmax] uppercase  rotate-[-5deg]  font-extrabold font-4   flex-center customBG-13 text-black py-[1vmax] ' >
                            Specials
                        </h3>
                        <div className="grid grid-cols-[2.5fr_1fr] items-center">
                            <div className='p-[2vmax] '>
                                <div className="grid  items-center border-b-[0.2vmax]  border-dashed border-[#FA8907] pb-[1vmax]">
                                    <br />
                                    <br />
                                    <div className='relative' >
                                        <h4 className='text-[1.4vmax] font-4 font-extrabold  font-bold text-white mb-[0.5vmax]' >
                                           Smashed Burrito
                                        </h4>
                                        <p className='text-white font-[400] text-[1vmax] pb-[0.5vmax]' >
                                            Smash pattie, fries, cheese, pickles, grilled onions
                                        </p>
                                        <br />
                                        <h3 className='text-[2vmax] uppercase  rotate-[-5deg]  font-extrabold font-1   w-fit customBG-12 text-black pt-[0.5vmax] pb-[1vmax] px-[1.6vmax] absolute bottom-[-50%] left-[-0.5vmax] ' >
                                            $ 15.99
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <img src={Img9} alt="" className='scale-[2] ml-[-2vmax]' />
                            </div>

                        </div>
                        <div className="grid grid-cols-[2.5fr_1fr] items-center">
                            <div className='p-[2vmax] '>
                                <div className="grid  items-center border-b-[0.2vmax]  border-dashed border-[#FA8907] pb-[1vmax]">

                                    <div className='relative' >
                                        <h4 className='text-[1.4vmax] font-4 font-extrabold  font-bold text-white mb-[0.5vmax]' >
                                          Surf & Turf Burrito
                                        </h4>
                                        <p className='text-white font-[400] text-[1vmax] pb-[0.5vmax]' >
                                            Shrimp, smash pattie, fries, avocado sauce
                                        </p>
                                        <br />
                                        <h3 className='text-[2vmax] uppercase  rotate-[-5deg]  font-extrabold font-1   w-fit customBG-11 text-black pt-[0.5vmax] pb-[1vmax] px-[1.6vmax] absolute bottom-[-50%] left-[-0.5vmax] ' >
                                            $ 18.99
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <img src={Img10} alt="" className='scale-[2] ml-[-3vmax]' />
                            </div>

                        </div>
                        <div className="grid grid-cols-[2.5fr_1fr] items-center">
                            <div className='p-[2vmax] '>
                                <div className="grid  items-center border-b-[0.2vmax]  border-dashed border-[#FA8907] pb-[1vmax]">

                                    <div className='relative' >
                                        <h4 className='text-[1.4vmax] font-4 font-extrabold  font-bold text-white mb-[0.5vmax]' >
                                          Loaded Fries
                                        </h4>
                                        <p className='text-white font-[400] text-[1vmax] pb-[0.5vmax]' >
                                            Texas chili, jalapeños, queso, sour cream, fritos
                                        </p>
                                        <br />
                                        <h3 className='text-[2vmax] uppercase  rotate-[-5deg]  font-extrabold font-1   w-fit customBG-12 text-black pt-[0.5vmax] pb-[1vmax] px-[1.6vmax] absolute bottom-[-50%] left-[-0.5vmax] ' >
                                            $ 14.99
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <img src={Img11} alt="" className='scale-[2] ml-[-3vmax]' />
                            </div>

                        </div>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
            </section>
             <div className="fixed bottom-[2vmax] left-[50%] -translate-x-1/2 p-[1vmax_4vmax] rounded-full customBG-10 shadow-1   hover:translate-y-[-1vmax] ">
                <Link to={`/`} className=' text-white text-[1.5vmax] font-extrabold' >
                    Go Back
                </Link>
            </div>
        </Fragment>
    )
}

export default MenuTwo